<template>
  <div class="mmain" v-title data-title="活动展示">
      <mNewsList fenlei="活动展示"></mNewsList>
  </div>
</template>
<script>
import mNewsList from "@/components/mNewsList.vue";
import Bus from "@/utils/bus.js";
export default {
  data() {
    return {
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
  },
  components: {
    mNewsList
  }
};
</script>
<style lang="less" scoped>
.mmain {
  width: 100%;
}
</style>